<template>
  <div id="app">
    <NavBar v-if="loggedIn" class="navbar" />
    <router-view
      class="main"
      :class="styleFullSize" />
    <TabMenu v-if="loggedIn" class="tab-menu" />
    <Popup v-if="$store.state.popup.show" />
    <PopupQuiz v-if="$store.state.popupQuiz.show" />
    <PopupTourism v-if="$store.state.popupTourism.show" />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import TabMenu from '@/components/TabMenu'
import Popup from '@/components/Popup'
import PopupQuiz from '@/components/PopupQuiz'
import PopupTourism from '@/components/PopupTourism'

export default {
  created: function () {
    this.$store.dispatch('locale/changeLang', 'ja')
    this.$store.dispatch('option/retrieveOptions')
    this.$store.dispatch('locale/fetch')
    this.$store.dispatch('gps/keepUpdate')
  },

  components: {
    NavBar,
    TabMenu,
    Popup,
    PopupQuiz,
    PopupTourism
  },

  computed: {
    styleFullSize: function () {
      if (this.$route.meta.fullSize) {
        return { 'full-size': true }
      }
      return {}
    },

    loggedIn: function () {
      return this.$route.meta.auth
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  font-family: 'Noto Sans JP', "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", "sans-serif"
}

#app {
  display: flex;
  height: 100vh;
  flex-direction: column;
}

.navbar {
  height: $ph-nav;
}

.main {
  height: $ph-content;
  overflow-y: auto;
}

.full-size {
  height: 100%;
}

</style>

<style lang="scss" scoped>
.tab-menu {
  height: $ph-tab;
  box-sizing: border-box;
}
</style>
